var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17351",
    d: "M9.306 0a1.5 1.5 0 011.1 2.515L4.906 8.5H30.5a1.5 1.5 0 010 3H4.914l5.5 5.985a1.5 1.5 0 11-2.208 2.029L.4 11.014a1.49 1.49 0 01-.39-.925 1.544 1.544 0 01.011-.28 1.5 1.5 0 01.3-.725 1.2 1.2 0 01.087-.1l7.8-8.491a1.493 1.493 0 011.1-.485",
    fill: "currentColor"
  })));
}
export default SvgArrowLeft;